
import { Component, Prop, Vue } from "nuxt-property-decorator";
import BaseDataTile from "./BaseDataTile.vue";
import BasePriceDisplay from "./BasePriceDisplay.vue";
import HistoricalPriceDisplay from "./HistoricalPriceDisplay.vue";

@Component({
  components: {
    BaseDataTile,
    BasePriceDisplay,
    HistoricalPriceDisplay,
  },
})
export default class SingleDataTile extends Vue {
  @Prop() headline: string;
  @Prop() description: string;
  @Prop() disclaimer: string;
  @Prop({ default: false }) showBatchLabel: boolean;
  @Prop({ default: false }) isLoading: boolean;
  @Prop({
    type: Object,
    required: true,
  })
  priceData: {
    name: string;
    currentPrice: { value: number; changedAtUnix: number };
    lastPrice: { value: number; changedAtUnix: number };
    relativeChange: number;
  };
}
